import {ServiceCategory} from "@/ui/service-block/ServiceBlock";

export const GENERAL_SERVICE_TERM_1 = "Formwork";
export const GENERAL_SERVICE_TERM_2 = "Steel Fixing";
export const GENERAL_SERVICE_TERM_3 = "Formwork Services";
export const serviceBlockData : ServiceCategory[] = [
    {
        title: "Concrete Formwork & Structural Solutions",
        services: [
            "Residential & Commercial Formwork Contractors Sydney",
            "Reinforced Concrete Slabs & Raft Foundations Sydney",
            "Formwork for Stairs, Columns & Walls Sydney",
            "Custom Concrete Structures Sydney",
            "Industrial & Civil Formwork Projects Sydney",
            "Formwork Design & Engineering Support Sydney",
            "Reliable Concrete Framework Specialists Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-1.jpg",
    },
    {
        title: "Excavation & Groundworks Services",
        services: [
            "Bulk Earthmoving & Site Preparation Sydney",
            "Detailed Excavation & Precision Digging Sydney",
            "Basement Excavation & Retaining Systems Sydney",
            "Trenching for Utilities & Infrastructure Sydney",
            "Soil Removal & Rock Breaking Sydney",
            "Excavation for Driveways & Foundations Sydney",
            "Safe & Efficient Groundwork Contractors Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-2.jpg",
    },
    {
        title: "Concreting & Reinforcement Works",
        services: [
            "Concrete Pouring & Pumping Services Sydney",
            "Reinforcement & Steelfixing Contractors Sydney",
            "High-Rise & Multi-Storey Concreting Sydney",
            "Driveway & Outdoor Concrete Finishes Sydney",
            "Structural Concrete for Civil Projects Sydney",
            "Commercial & Industrial Concreting Sydney",
            "Reliable Concrete Reinforcement Specialists Sydney"
        ],
        imageUrl: "/images/services/stand-alone-service-points/sas-3.jpg",
    }
]




